import { DesktopDisplayContainer } from '@components/DeviceContainer'
import React from 'react'
import styled from 'styled-components'
import useR18Alert from './useR18Alert'
import tw from 'twin.macro'

const BlurContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  backdrop-filter: brightness(60%) blur(10px);
`
const ModalContainer = styled.div`
  height: 625px;
  width: 350px;
  background-color: #2c2593;
  border-radius: 8px;
  padding: 16px 16px;
  color: white;
`

const LollipopImage = styled.img`
  display: block;
  width: 140px;
  height: 140px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 10px;
`

const TitleContainer = styled.div`
  ${tw`font-semibold text-article`}
  text-align: center;
  margin-top: 24px;
`

const DescriptionContainer = styled.div`
  ${tw`text-h6`}
  margin-top: 8px;
`

const YesMessageContainer = styled.div`
  cursor: pointer;
  margin-top: 40px;
  ${tw`bg-primary-indigo`}
  text-align: center;
  height: 56px;
  border-radius: 28px;
  line-height: 56px;
`

const NoMessageContainer = styled.div`
  cursor: pointer;
  color: black;
  margin-top: 8px;
  height: 56px;
  border-radius: 28px;
  line-height: 56px;
  text-align: center;
  background-color: white;
`

const DesktopR18Alert = () => {
  const { title, description, noMessage, yesMessage, handleYesClick, handleNoClick, shouldShow } =
    useR18Alert()
  if (!shouldShow) {
    return null
  }
  return (
    <DesktopDisplayContainer>
      <BlurContainer>
        <ModalContainer>
          <LollipopImage src={'/images/r18Alert/hey-lollipop.png'} />
          <TitleContainer>{title}</TitleContainer>
          <DescriptionContainer>{description}</DescriptionContainer>
          <YesMessageContainer onClick={handleYesClick}>{yesMessage}</YesMessageContainer>
          <NoMessageContainer onClick={handleNoClick}>{noMessage}</NoMessageContainer>
        </ModalContainer>
      </BlurContainer>
    </DesktopDisplayContainer>
  )
}

export default DesktopR18Alert
